import store from "../store";
import jwt_decode from "jwt-decode";
import { Toast } from '@capacitor/toast';
import { getPanelUuid, getPreference } from "./apiFunctions";
export const clearCookies = () => {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        // name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
        name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=hire3x.com;";
    }
  };

export const checkForAccess = (project) => {
  if (document.cookie.length > 0) {
    const data = document.cookie.split(";");

    for (const cookie of data) {
      const index = cookie.indexOf("=");
      if (index === -1) continue;

      const key = cookie.slice(0, index).trim();
      const value = cookie.slice(index + 1);

      if (
        key === project &&
        value !== "no-access" &&
        value !== "ExternalPanelist"
      ) {
        return JSON.parse(value);
      }
    }
  }
  return null;
};

export const getloginData = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "loginData") {
        return JSON.parse(cur[1]);
      }
    }
  }
  return null;
};

export const getToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "accessToken") {
        return cur[1];
      }
    }
  }
  return null;
};

export const getRefreshToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "refreshToken") {
        return cur[1];
      }
    }
  }
  return null;
};

export const getAccessProjects = () => {
  let projects = [];
  if (checkForAccess("recruitment")) {
    projects.push("recruitment");
  }
  if (checkForAccess("assessment")) {
    projects.push("assessment");
  }
  if (checkForAccess("training")) {
    projects.push("training");
  }
  if (checkForAccess("collegeDashboard")) {
    projects.push("collegeDashboard");
  }
  return projects;
};

export const checkForPanelAccess = async (uuid, next) => {
  const res = await getPanelUuid(uuid);
  if (res.status == 200) {
    let data = {
      value: "recruitment",
      panelId: uuid,
    };
    store.dispatch("userVUEX/goToPage", data);
  } else {
    console.log("no access to feedback link");
    gotoLogin(next);
  }
};

export const checkTokenExpiry = () => {
  let cookieToken = getToken();
  let decoded = jwt_decode(cookieToken);
  let expirationTime = decoded.exp * 1000;
  let currentTime = Math.floor(new Date().getTime());
  if (currentTime >= expirationTime) {
    return true;
  } else {
    return false;
  }
};

export const getPreferenceData = async (isLaptop, next) => {
  const res = await getPreference();
  if (res.status == 200) {
    if (res.data.data.defaultModule && isLaptop) {
      store.dispatch("userVUEX/goToPage", res.data.data.defaultModule);
    } else if (isLaptop && getAccessProjects().length !== 0) {
      store.dispatch("userVUEX/goToPage", getAccessProjects()[0]);
    } else {
      gotoLogin(next);
    }
  } else {
    if (getAccessProjects().length !== 0) {
      store.dispatch("userVUEX/goToPage", getAccessProjects()[0]);
    } else {
      gotoLogin(next);
    }
  }
};

const checkForPanelLogin = (next) => {
  let recData = checkForAccess("recruitment");
  if (
    recData.userPermissions &&
    recData.userPermissions.isActive &&
    recData.roleName === "Panelist"
  ) {
    store.dispatch("userVUEX/goToPage", "candidate");
  } else {
    gotoLogin(next);
  }
};

export const checkExternalPanelist = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "recruitment" && cur[1] === "ExternalPanelist") {
        return true;
      }
    }
  }
  return null;
};

export const checkIfLoggedIn = (to, isLaptop, next) => {
  if (document.cookie.length != 0 && getToken() && getRefreshToken()) {
    store.commit("userVUEX/setCollege", {});
    if (!checkTokenExpiry()) {
      let projects = [
        "assessment",
        "training",
        "recruitment",
        "collegeDashboard",
      ];
      if (to.query.redirectTo && to.query.courseID) {
        store.commit("userVUEX/setTrainingRedirect", {
          redirect: to.query.redirectTo,
          courseID: to.query.courseID,
        });
      } else {
        store.commit("userVUEX/setTrainingRedirect", {});
      }
      if (to.query.from == "recruitment" && to.query.redirect) {
        store.commit("userVUEX/setPageRedirect", to.query.redirect);
      } else if (to.query.from == "recruitment" && to.query.intid) {
        store.commit("userVUEX/setPageRedirect", {
          intid: to.query.intid,
          type: to.query.type,
        });
      } else {
        store.commit("userVUEX/setPageRedirect", null);
      }
      if (!to.query.from) {
        if (checkForAccess("candidate")) {
          store.dispatch("userVUEX/goToPage", "candidate");
        } else if (getAccessProjects().length !== 0) {
          if (getAccessProjects().length === 1) {
            if (projects.includes(getAccessProjects()[0]) && isLaptop) {
              store.dispatch("userVUEX/goToPage", getAccessProjects()[0]);
            } else if (getAccessProjects()[0] === "recruitment" && !isLaptop) {
              checkForPanelLogin(next);
            } else {
              gotoLogin(next);
            }
          } else {
            getPreferenceData(isLaptop, next);
          }
        } else {
          gotoLogin(next);
        }
      } else if (projects.includes(to.query.from)) {
        if (checkForAccess(to.query.from)) {
          if (to.query.from === "training") {
            store.dispatch("userVUEX/goToPage", to.query.from);
          } else if (
            to.query.from === "recruitment" &&
            to.query.uuid &&
            to.query.panel
          ) {
            checkForPanelAccess(to.query.uuid, next);
          } else if (isLaptop) {
            store.dispatch("userVUEX/goToPage", to.query.from);
          } else if (to.query.from === "recruitment" && !isLaptop) {
            checkForPanelLogin(next);
          } else {
            gotoLogin(next);
          }
        } else if (
          to.query.from === "recruitment" &&
          to.query.uuid &&
          to.query.panel &&
          checkExternalPanelist()
        ) {
          checkForPanelAccess(to.query.uuid, next);
        } else {
          gotoLogin(next);
        }
      }
    } else {
      gotoLogin(next);
    }
  } else {
    gotoLogin(next);
  }
};

const gotoLogin = (next) => {
  clearCookies();
  next();
};

export const getProjectUrl = (project) => {
  let url;
  if(project == 'Recruitment') url="recruitment";
  else if(project == 'Assessment') url="judge";
  else if(project == 'Training') url="trainingadmin"
  let finalUrl; 
  if(project == 'Training-Candidate') finalUrl = 'https://candidate.hire3x.com/training/';
  else if(project == 'Candidate') finalUrl = 'https://candidate.hire3x.com/builder/';
  else finalUrl = `https://${url}.hire3x.com/`;
  return finalUrl;
}

export const showToast = async (message) => {
  await Toast.show({
    text: message,
    duration: 'long', // 'short' (2s) or 'long' (3.5s)
    position: 'bottom', // 'top', 'center', 'bottom'
  });
}
